import { AreaSlugMap } from '~/constants'

export const getAreaSlugList = (
  filterCriteria: 'stats-page' | 'games-page' | 'games-growth-page' | 'games-rank-page' | 'training-areas-page',
): AreaSlugType[] => {
  if (filterCriteria === 'stats-page' || filterCriteria === 'training-areas-page') {
    return Object.values(AreaSlugMap)
      .map((area) => area.code)
      .filter((area) => area !== 'language')
      .sort((a, b) => {
        return AreaSlugMap[a].statsPageRank - AreaSlugMap[b].statsPageRank
      })
  }
  if (filterCriteria === 'games-page') {
    return Object.values(AreaSlugMap)
      .map((area) => area.code)
      .sort((a, b) => {
        return AreaSlugMap[a].gamesPageRank - AreaSlugMap[b].gamesPageRank
      })
  }
  if (filterCriteria === 'games-growth-page' || filterCriteria === 'games-rank-page') {
    return Object.values(AreaSlugMap).map((area) => area.code)
  }

  return Object.values(AreaSlugMap).map((area) => area.code)
}
